import { aiReportTypes } from '../types';

export function saveDialogFiles(files: aiReportTypes.DialogFile[]) {
  files.forEach((file, index) => {
    window.setTimeout(() => {
      const blob = new Blob([JSON.stringify(file.messages, null, 2)], {
        type: 'application/json',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = file.filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    }, index * 400);
  });
}
